import { render, staticRenderFns } from "./FieldItem.vue?vue&type=template&id=72df2f39&scoped=true"
import script from "./FieldItem.vue?vue&type=script&lang=js"
export * from "./FieldItem.vue?vue&type=script&lang=js"
import style0 from "./FieldItem.vue?vue&type=style&index=0&id=72df2f39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72df2f39",
  null
  
)

export default component.exports